import { TextField } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { StyledClientsEditNickname } from "../../clients/styledClients";

const ExclusionValueUpdateForm = ({ exclusion, t, notification, setNotification, setFetch }) => {
  const [currentValue, setCurrentValue] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const save = () => {
    if (!currentValue || currentValue === exclusion?.value) {
      setIsEdit(false);
      setCurrentValue(exclusion.value);
      return;
    }

    handleUpdate();
  };

  const cancel = () => {
    setIsEdit(false);
    setCurrentValue(exclusion?.value);
  };

  const handleUpdate = () => {
    let data = {
      value: currentValue
    };

    axios.put(`/api/service-exclusions/${exclusion.id}`, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setIsEdit(false);

        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successEdit") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    setCurrentValue(exclusion?.value);
  }, [exclusion]);

  return (
    <StyledClientsEditNickname>
      {isEdit ? (
        <div className="nickname-edit-form">
          <TextField
            id={`value.${exclusion.id}`}
            value={currentValue ?? exclusion?.value}
            onChange={(event) => setCurrentValue(event.target.value)}
          />
          <div className="nickname-edit-form__actions">
            <button
              className="table-action"
              onClick={save}
            >
              <span className="icon-light-check" />
              {t("exclusions.editForm.save")}
            </button>
            <button
              className="table-action table-action_danger"
              onClick={cancel}
            >
              <span className="icon-light-cancel" />
              {t("exclusions.editForm.cancel")}
            </button>
          </div>
        </div>
      ) : (
        <div className="nickname-edit">
          <div>{currentValue ?? exclusion?.value}</div>
          <button
            className="table-action table-action_info"
            onClick={() => setIsEdit(true)}
          >
            <span className="icon-light-edit" />
            {t("exclusions.editForm.edit")}
          </button>
        </div>
      )}
    </StyledClientsEditNickname>
  );
};

export default ExclusionValueUpdateForm;